module.exports = __webpack_public_path__ + "img/pr-33.b7e72ada.png";